// Used for Search Box - JSP include component version (to keep functionality after implementing search suggestion)

const simpleSearch = {
    simpleSearchWrapper: undefined,
    init() {
        this.simpleSearchWrapper.on('keydown', '.search-component__field', function (evt) {
            const $input = $(evt.target);
            if ($input.val() !== '') {
                $input.siblings('.js-search-box__reset').removeClass('d-none');
            } else {
                $input.siblings('.js-search-box__reset').addClass('d-none');
            }
        });

        this.simpleSearchWrapper.on('click', '.js-search-box__reset', function (evt) {
            $(evt.target).parents('.search-component__form')
                         .find('.search-component__field')
                         .val('')
                         .focus();
        });
    },

    cacheSelector() {
        this.simpleSearchWrapper = $('body').find('.search-component--classic');
    }
}

$(() => {
    simpleSearch.cacheSelector();
    simpleSearch.init();
});